<template>
  <div class="docs">
    <HeroBanner :title="'My Documents'" :subtitle="isAdmin ? `For ${currentUserProfile.firstName} ${currentUserProfile.lastName}` : null" v-if="currentUserProfile"/>
    <section>
      <p v-if="loading">Loading...</p>
      <table v-else-if="files.length">
        <tr>
          <th>
            Filename
          </th>
          <th>
            File size
          </th>
          <th v-if="isAdmin">
            Actions
          </th>
        </tr>
        <tr v-for="file in files" :key="file.name">
          <td>
            <a :href="file.url" v-html="file.name" target="_blank"/>
          </td>
          <td v-html="`${(file.metadata.size / 1000000).toFixed(2)} MB`"/>
          <td v-if="isAdmin">
            <a href="#" @click.prevent="deleteFile(file.name)">Delete</a>
          </td>
        </tr>
      </table>
      <p v-else>
        No files to be found here just yet!
      </p>
    </section>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import * as fb from '@/library/firebase'
import 'firebase/storage'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Docs',
  components: {
    HeroBanner
  },
  data() {
    return {
      loading: true,
      files: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUserProfile'
    ]),
    ...mapState([
      'isAdmin'
    ])
  },
  methods: {
    deleteFile(filename) {
      if (!confirm(`Are you sure you want to delete ${filename}? This cannot be undone`)) {
        return;
      }

      const storageRef = fb.storage.ref()

      // Create a reference to the file to delete
      const fileRef = storageRef.child(`docs/${this.currentUserProfile.uid}/${filename}`)

      // Delete the file
      fileRef.delete().then(function() {
        // File deleted successfully
        window.location.reload()
      }).catch(function(error) {
        alert('Error deleting file')
        console.error(error)
      })
    },
    loadDocs() {
      this.files = []
      if (this.currentUserProfile && !this.files.length) {
        const storageRef = fb.storage.ref()
        const listRef = storageRef.child(`docs/${this.currentUserProfile.uid}`)

        // Find all the prefixes (child folders) and items.
        listRef.listAll().then(res => {
          res.prefixes.forEach(folderRef => {
            // All the prefixes under listRef.
            folderRef.listAll().then(prefix => {
              prefix.items.forEach(itemRef => {
                // console.log('itemRef', itemRef.name) // eslint-disable-line
                this.pushFile(itemRef)
              })
            })
          })
          res.items.forEach(itemRef => {
            // console.log('itemRef', itemRef) // eslint-disable-line
            // All the items under listRef.
            this.pushFile(itemRef)
            setTimeout(() => {
              // TODO: don't use setTimeout, figure out how to set loading to false when everything is really finished loading
              this.loading = false
            }, 500);
          })
          if (!res.items.length) {
            this.loading = false;
          }
        }).catch(error => {
          this.loading = false
          console.error(error)
          // Uh-oh, an error occurred!
        })
      }
    },
    pushFile(itemRef) {
      const name = itemRef.name
      itemRef.getDownloadURL().then(url => {
        itemRef.getMetadata().then(metadata => {
          // Skip duplicates
          if (this.files.find(f => f.name === name)) {
            return;
          }
          this.files.push({ metadata, name, url })
        }).catch(error => {
          console.error(error)
          // Uh-oh, an error occurred!
        })
      })
    }
  },
  mounted() {
    if (this.currentUserProfile) {
      this.loadDocs()
    }
  },
  watch: {
    currentUserProfile() {
      if (this.currentUserProfile) {
        this.loadDocs()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.docs {
  section {
    padding: 2rem;
    flex-direction: column;
    text-align: center;
  }
  table {
    width: 100%;
    border: solid 1px #ccc;
    border-collapse: collapse;
    th, td {
      border: solid 1px #ccc;
      padding: 1rem;
      text-align: left;
    }
    th {
      background-color: #dae6ec;
    }
  }
}
</style>